module.exports = __webpack_public_path__ + "static/media/ic-date.83ff5b07.svg";